import { RoLabor } from '../interface/ro-labor';
import { RoLaborFull } from '../interface/ro-labor-full';
import { laborStates } from '../shared/lists/labor-states';
import { ApiFloat } from './api-float';
import { Utilities } from './utilities';


export class RoLaborFullUtilities extends Utilities {

  static changed(a: RoLaborFull, b: RoLaborFull): boolean {
    return !this.equalString(a.labor.code, b.labor.code)
      || !this.equalString(a.labor.description, b.labor.description)
      || !this.equalNumberWithDefault(a.amount, b.amount, 1)
      || !this.equalNumberWithDefault(a.labor.saleValue, b.labor.saleValue, 0)
      || !this.equalNumberWithDefault(a.available, b.available, laborStates.waiting.id);
  }


  static hasMechanicAssigned(roLabor: RoLaborFull, useMultipleMechanics: boolean): boolean {
    if (useMultipleMechanics) {
      return Boolean(roLabor.mechanics?.length) && Boolean(roLabor.chiefMechanic);
    }

    return Boolean(roLabor.mechanic);
  }

  static complyApp(roLabor: RoLaborFull): RoLaborFull {
    const observation = roLabor.observation;
    roLabor.saleValue /= 100;
    roLabor.discountValue /= 100;
    roLabor.liquidValue /= 100;
    // Está sendo invertido o campo de observações para que as observações que ja existiam (campo 'observation') aparecam como padrão no pdf
    roLabor.observation = roLabor.internalObservation;
    roLabor.internalObservation = observation;
    return roLabor;
  }

  static complyApi(roLabor: RoLaborFull): RoLabor {
    if (roLabor.available == 0) {
      roLabor.available = "0" as any;
    }

    if(!roLabor.labor){
      console.warn("Serviço da OS sem serviço do cadastro", roLabor)
    }

    const laborId = typeof roLabor.labor == 'string' ? roLabor.labor : roLabor.labor.id;

    let apiLabor = {
      "labor": laborId,
      "amount": roLabor.amount,
      "saleValue": ApiFloat(roLabor.saleValue),
      // available: Number.isFinite(roLabor.available) ? roLabor.available : laborStates.waiting.id,
      "available": roLabor.available,
      "observation": roLabor.internalObservation,
      "internalObservation": roLabor.observation,
      // ✅ CORREÇÃO: Removido campos calculados - backend será responsável
      // "discountValue": ApiFloat(roLabor.discountValue),
      // "discountProp": ApiFloat(roLabor.discountProp),
      // "discountPropGeral": ApiFloat(roLabor.discountPropGeral),
      // "liquidValue": ApiFloat(roLabor.liquidValue),
      // ✅ CORREÇÃO: additionalDiscount será enviado condicionalmente
      // "additionalDiscount": roLabor.additionalDiscount,
      "lastUpdate": new Date(),
      "custom": roLabor.custom || 0,
    };

    // ✅ CORREÇÃO: Enviar APENAS o campo de desconto que foi alterado
    // Detectar qual campo o usuário modificou via flag
    const lastChanged = roLabor['__lastDiscountFieldChanged'];
    
    if (lastChanged === 'discountValue') {
      // Usuário alterou VALOR ABSOLUTO → enviar apenas discountValue
      apiLabor["discountValue"] = ApiFloat(roLabor.discountValue);
    } else if (lastChanged === 'additionalDiscount') {
      // Usuário alterou PERCENTUAL → enviar apenas additionalDiscount
      apiLabor["additionalDiscount"] = roLabor.additionalDiscount;
    } else {
      // Caso padrão: enviar ambos (para compatibilidade com código legado)
      apiLabor["discountValue"] = ApiFloat(roLabor.discountValue);
      apiLabor["additionalDiscount"] = roLabor.additionalDiscount;
    }

    // Limpar flag após serialização
    if (roLabor['__lastDiscountFieldChanged']) {
      delete roLabor['__lastDiscountFieldChanged'];
    }

    if (roLabor.id) {
      apiLabor["id"] = roLabor.id;
    }
    if (roLabor.status) {
      apiLabor["status"] = roLabor.status;
    }
    if (roLabor.timeTrackers) {
      apiLabor["timeTrackers"] = roLabor.timeTrackers;
    }
    if (roLabor.hasOwnProperty("blocked")) {
      apiLabor["blocked"] = roLabor.blocked;
    }
    if (roLabor.hasOwnProperty("running")) {
      apiLabor["running"] = roLabor.running;
    }
    if (roLabor.mechanic) {
      apiLabor["mechanic"] = roLabor.mechanic;
    } else {
      apiLabor["mechanic"] = "";
    }
    if (roLabor.mechanics) {
      apiLabor["mechanics"] = roLabor.mechanics;
    }
    if (roLabor.chiefMechanic) {
      apiLabor["chiefMechanic"] = roLabor.chiefMechanic;
    }
    if (roLabor.labor && roLabor.labor.id) {
      apiLabor["labor"] = roLabor.labor.id;
    }
    if (roLabor.itenBlock) {
      apiLabor["itenBlock"] = roLabor.itenBlock;
    }
    return apiLabor;
  }

}
